import {Routes} from '@angular/router';
import {NavigationKey} from './enums/navigation-key-type';
import {WelcomeComponent} from "./components/flow-views/welcome/welcome.component";
import {
  InsuranceInformationComponent
} from "./components/flow-views/disclaimer/insurance-information/insurance-information.component";
import {
  ClaimReportDutyInformationComponent
} from "./components/flow-views/disclaimer/claim-report-duty-information/claim-report-duty-information.component";
import {
  UserParticipationIdentificationComponent
} from "./components/flow-views/accident-report/user-participation-identification/user-participation-identification.component";
import {
  MultiplePartyInvolvementCheckComponent
} from "./components/flow-views/accident-report/multiple-party-involvement-check/multiple-party-involvement-check.component";
import {
  NoProcessingPossibleComponent
} from "./components/flow-views/accident-report/no-processing-possible/no-processing-possible.component";
import {
  EnterLicensePlateComponent
} from "./components/flow-views/accident-report/enter-license-plate/enter-license-plate.component";
import {
  AccidentLocationComponent
} from "./components/flow-views/accident-report/accident-location/accident-location.component";
import {DamageTypeComponent} from "./components/flow-views/accident-report/damage-type/damage-type.component";
import {
  VehicleInvolvedComponent
} from "./components/flow-views/accident-report/vehicle-involved/vehicle-involved.component";
import {
  CarPartsBeingInvolvedComponent
} from "./components/flow-views/accident-report/car-parts-being-invovled/car-parts-being-involved.component";
import {
  IncidentDescriptionComponent
} from "./components/flow-views/accident-report/bodily-injured-accident-description-list/incident-description.component";
import {
  DetailAccidentDescriptionComponent
} from "./components/flow-views/accident-report/detail-accident-description/detail-accident-description.component";
import {
  AccidentReportFinishedComponent
} from "./components/flow-views/accident-report/accident-report-finished/accident-report-finished.component";
import {RideReasonComponent} from "./components/flow-views/ride-information/ride-reason/ride-reason.component";
import {DriverAgeComponent} from "./components/flow-views/ride-information/driver-age/driver-age.component";
import {
  AlcoholConsumptionComponent
} from "./components/flow-views/ride-information/alcohol-consumption/alcohol-consumption.component";
import {PoliceReportComponent} from "./components/flow-views/ride-information/police-report/police-report.component";
import {
  WitnessInformationComponent
} from "./components/flow-views/ride-information/witness-information/witness-information.component";
import {
  PolicePreformedDrugTestComponent
} from "./components/flow-views/ride-information/police-preformed-drug-test/police-preformed-drug-test.component";
import {
  PotentialTechnicalDefectComponent
} from "./components/flow-views/ride-information/potential-technical-defect/potential-technical-defect.component";
import {
  FaultAllocationComponent
} from "./components/flow-views/ride-information/fault-allocation/fault-allocation.component";
import {
  ThirdPartyContactInformationComponent
} from "./components/flow-views/ride-information/third-party-contact-information/third-party-contact-information.component";
import {
  RideInformationFinishedComponent
} from "./components/flow-views/ride-information/ride-information-finished/ride-information-finished.component";
import {
  DocumentUploadOverviewComponent
} from "./components/flow-views/document-upload/document-upload-overview/document-upload-overview.component";
import {
  DocumentUploadPoliceReportComponent
} from "./components/flow-views/document-upload/document-upload-police-report/document-upload-police-report.component";
import {
  DocumentUploadFinishedComponent
} from "./components/flow-views/document-upload/document-upload-finished/document-upload-finished.component";
import {
  PersonalInformationComponent
} from "./components/flow-views/personal-information/personal-information/personal-information.component";
import {
  PersonalInformationFinishedComponent
} from "./components/flow-views/personal-information/personal-information-finished/personal-information-finished.component";
import {
  DataIsCorrectComponent
} from "./components/flow-views/data-is-correct/data-is-correct/data-is-correct.component";
import {OverviewComponent} from "./components/flow-views/overview/overview/overview.component";
import {TokeRedirectComponent} from "./components/common/toke-redirect/toke-redirect.component";
import {
  ContactValidationComponent
} from "./components/flow-views/overview/contact-validation/contact-validation.component";
import {
  OverviewFinishedComponent
} from "./components/flow-views/overview/overview-finished/overview-finished.component";
import {
  ImportanceOfQuickResponseComponent
} from "./components/flow-views/disclaimer/importance-of-quick-response/importance-of-quick-response.component";
import {WhatIsCoveredComponent} from "./components/flow-views/disclaimer/what-is-covered/what-is-covered.component";
import {AccidentRoleComponent} from "./components/flow-views/accident-report/accident-role/accident-role.component";
import {ActiveRideComponent} from "./components/flow-views/ride-information/active-ride/active-ride.component";
import {
  VehicleAccidentStatusComponent
} from "./components/flow-views/accident-report/vehicle-accident-status/vehicle-accident-status.component";
import {WhatToDoComponent} from "./components/flow-views/information-pages/what-to-do/what-to-do.component";
import {
  AboutInsurerComponent
} from "./components/flow-views/information-pages/about-insurer/about-insurer.component";
import {
  AboutPolicyholderComponent
} from "./components/flow-views/information-pages/about-policyholder/about-policyholder.component";
import {ImprintComponent} from "./components/flow-views/information-pages/imprint/imprint.component";
import {DataPrivacyComponent} from "./components/flow-views/information-pages/data-privacy/data-privacy.component";
import {FaqComponent} from "./components/flow-views/information-pages/faq/faq.component";
import {
  TokenExpiredRestartComponent
} from "./components/flow-views/token-expired/token-expired-restart/token-expired-restart.component";
import {
  RouteAggregatorComponent
} from "./components/flow-views/debug/route-aggregator/route-aggregator.component";
import {
  WitnessInformationRedirectComponent
} from "./components/flow-views/ride-information/witness-information-redirect/witness-information-redirect.component";
import {
  PotentialTechnicalDefectRedirectComponent
} from "./components/flow-views/ride-information/potential-technical-defect-redirect/potential-technical-defect-redirect.component";
import {DebugComponent} from "./components/flow-views/debug/debug.component";
import {MockingComponent} from "./components/flow-views/debug/mocking/mocking.component";
import {PdfGeneratorComponent} from "./components/flow-views/debug/pdf-generator/pdf-generator.component";
import {SingleViewComponent} from "./components/flow-views/debug/single-view/single-view.component";

export const routes: Routes = [
  {
    path: NavigationKey['welcome'], component: WelcomeComponent
  },
  {
    path: NavigationKey['insurance-information'], component: InsuranceInformationComponent
  },
  {
    path: NavigationKey['claim-report-duty'], component: ClaimReportDutyInformationComponent
  },
  {
    path: NavigationKey['quick-response-info'], component: ImportanceOfQuickResponseComponent
  },
  {
    path: NavigationKey['what-is-covered'], component: WhatIsCoveredComponent
  },
  {
    path: NavigationKey['user-participation'], component: UserParticipationIdentificationComponent
  },
  {
    path: NavigationKey['multiple-party-involvement'], component: MultiplePartyInvolvementCheckComponent
  },
  {
    path: NavigationKey['no-processing-possible'], component: NoProcessingPossibleComponent
  },
  {
    path: NavigationKey['enter-license-plate'], component: EnterLicensePlateComponent
  },
  {
    path: NavigationKey['accident-location'], component: AccidentLocationComponent
  },
  {
    path: NavigationKey['damage-type'], component: DamageTypeComponent
  },
  {
    path: NavigationKey['accident-role'], component: AccidentRoleComponent
  },
  {
    path: NavigationKey['vehicle-involved'], component: VehicleInvolvedComponent
  },
  {
    path: NavigationKey['vehicle-accident-status'], component: VehicleAccidentStatusComponent
  },
  {
    path: NavigationKey['car-parts-involved'], component: CarPartsBeingInvolvedComponent
  },
  {
    path: NavigationKey['incident-description'], component: IncidentDescriptionComponent
  },
  {
    path: NavigationKey['detail-accident-description'], component: DetailAccidentDescriptionComponent
  },
  {
    path: NavigationKey['accident-report-finished'], component: AccidentReportFinishedComponent
  },
  {
    path: NavigationKey['ride-reason'], component: RideReasonComponent
  },
  {
    path: NavigationKey['driver-age'], component: DriverAgeComponent
  },
  {
    path: NavigationKey['active-ride'], component: ActiveRideComponent
  },
  {
    path: NavigationKey['alcohol-consumption'], component: AlcoholConsumptionComponent
  },
  {
    path: NavigationKey['police-report'], component: PoliceReportComponent
  },
  {
    path: NavigationKey['police-drug-test'], component: PolicePreformedDrugTestComponent
  },
  {
    path: NavigationKey['witness-details'], component: WitnessInformationComponent
  },
  {
    path: NavigationKey['witness-information'], component: WitnessInformationRedirectComponent
  },
  {
    path: NavigationKey['technical-issue'], component: PotentialTechnicalDefectComponent
  },
  {
    path: NavigationKey['potential-technical-defect'], component: PotentialTechnicalDefectRedirectComponent
  },
  {
    path: NavigationKey['who-is-to-blame'], component: FaultAllocationComponent
  },
  {
    path: NavigationKey['third-party-information'], component: ThirdPartyContactInformationComponent
  },
  {
    path: NavigationKey['ride-information-finish'], component: RideInformationFinishedComponent
  },
  {
    path: NavigationKey['document-upload-overview'], component: DocumentUploadOverviewComponent
  },
  {
    path: NavigationKey['document-upload-police-report'], component: DocumentUploadPoliceReportComponent
  },
  {
    path: NavigationKey['document-upload-finished'], component: DocumentUploadFinishedComponent
  },
  {
    path: NavigationKey['personal-information'], component: PersonalInformationComponent
  },
  {
    path: NavigationKey['personal-information-finished'], component: PersonalInformationFinishedComponent
  },
  {
    path: NavigationKey['data-correctness-confirmation'], component: DataIsCorrectComponent
  },
  {
    path: NavigationKey['overview'], component: OverviewComponent
  },
  {
    path: NavigationKey['what-to-do'], component: WhatToDoComponent
  },
  {
    path: NavigationKey['about-insurer'], component: AboutInsurerComponent
  },
  {
    path: NavigationKey['about-policyholder'], component: AboutPolicyholderComponent
  },
  {
    path: NavigationKey['imprint'], component: ImprintComponent
  },
  {
    path: NavigationKey['data-privacy'], component: DataPrivacyComponent
  },
  {
    path: NavigationKey['faq'], component: FaqComponent
  },
  {path: 'claim/:token', component: TokeRedirectComponent},
  {path: NavigationKey['contact-validation'], component: ContactValidationComponent},
  {path: NavigationKey['finish'], component: OverviewFinishedComponent},
  {path: NavigationKey['token-expired'], component: TokenExpiredRestartComponent},
  {
    path: 'debug',
    component: DebugComponent,
    children: [
      {path: 'mocking', component: MockingComponent},
      {path: 'routes', component: RouteAggregatorComponent},
      {path: 'pdf-generator', component: PdfGeneratorComponent},
      {path: 'single-view', component: SingleViewComponent},
      {path: '', redirectTo: 'mocking', pathMatch: 'full'}
    ]
  },
  {path: NavigationKey['debug-routes'], redirectTo: 'debug/routes'},
  {
    path: '**',
    redirectTo: '', // or create a NotFoundComponent
  }
];
